/**
 * System-wide default values
 */
export const systemDefaultValues = Object.freeze({
    country: 'AU',
    currency: 'AUD',
    locale: 'en-AU',
    timezone: 'Australia/Sydney'
});
/**
 * Enum of user types for type safety
 */
export var USER_TYPE;
(function (USER_TYPE) {
    USER_TYPE["ADMIN"] = "admin";
    USER_TYPE["MANAGER"] = "manager";
    USER_TYPE["EXTERNAL_USER"] = "ext-user";
})(USER_TYPE || (USER_TYPE = {}));
export const SYSTEM_OPERATION = {
    BOOKING_CREATION: 'booking-creation',
    ADD_ON_CHARGE: 'add-on-charge'
};
export const ENQUEUE_SNACKBAR_AUTOHIDE_DURATION = 1000; // 1 second
export const FILE_SIZE_MAX_BYTES = 30 * 1024 * 1024; // 30MiB
export const FILE_SIZE_MAX_WARNING = "File size must be less than 30MB";
//# sourceMappingURL=system.js.map